export var hearingStatusLabels = {
    available: "Disponível",
    awaiting_recording: "Aguardando gravação",
    awaiting_minutes: "Aguardando ata",
    finished: "Concluída",
    canceled: "Cancelada",
};
export var hearingTypeLabels = {
    in_person: "Presencial",
    online: "Online",
    hybrid: "Híbrida",
};
/** @deprecated Use hearingTypeLabels */
export var hearingModalityLabels = hearingTypeLabels;
export var hearingSituationLabels = {
    in_progress: "Em andamento",
    closed: "Encerrada",
};
export var hearingStatusStyles = {
    available: { background: "#EAFBD7", color: "#28272C" },
    awaiting_recording: { background: "#FFF7D6", color: "#28272C" },
    awaiting_minutes: { background: "#FFF7D6", color: "#28272C" },
    finished: { background: "#EAECEE", color: "#28272C" },
    canceled: { background: "#FFE4E4", color: "#28272C" },
};
export var mapSituationToApi = function (situation) {
    if (situation === "Em andamento") {
        return "in_progress";
    }
    if (situation === "Encerrada") {
        return "closed";
    }
    return undefined;
};
export var mapTypeToApi = function (type) {
    if (type === "Presencial") {
        return "in_person";
    }
    if (type === "Online") {
        return "online";
    }
    if (type === "Híbrida") {
        return "hybrid";
    }
    return undefined;
};
/** @deprecated Use mapTypeToApi */
export var mapModalityToApi = mapTypeToApi;
export var canAccessVideoCall = function (status) {
    return status === "available";
};
export var canAccessRecording = function (hearing) {
    var _a;
    if (hearing.status !== "awaiting_recording" &&
        hearing.status !== "finished") {
        return false;
    }
    return Boolean((_a = hearing.recordingLink) === null || _a === void 0 ? void 0 : _a.trim());
};
export var isHearingLive = function (hearing) {
    if (hearing.status !== "available") {
        return false;
    }
    if (hearing.type !== "online" && hearing.type !== "hybrid") {
        return false;
    }
    if (!hearing.videoCallLink) {
        return false;
    }
    var startTime = new Date(hearing.startDate).getTime();
    if (!Number.isFinite(startTime) || startTime > Date.now()) {
        return false;
    }
    return true;
};
export var getHearingStatusDisplay = function (hearing) {
    if (isHearingLive(hearing)) {
        return { label: "Ao vivo", severity: "success" };
    }
    var severityMap = {
        available: "success",
        awaiting_recording: "warning",
        awaiting_minutes: "warning",
        finished: "info",
        canceled: "danger",
    };
    return {
        label: hearingStatusLabels[hearing.status],
        severity: severityMap[hearing.status],
    };
};
export var formatHearingAddress = function (hearing) {
    if (!hearing.address || !hearing.city || !hearing.state || !hearing.zipCode) {
        return "-";
    }
    var complement = hearing.complement ? ", ".concat(hearing.complement) : "";
    var number = hearing.number ? ", ".concat(hearing.number) : "";
    return "".concat(hearing.address).concat(number).concat(complement, " - ").concat(hearing.city, "/").concat(hearing.state, " - CEP ").concat(hearing.zipCode);
};
export var getParticipationActionLabel = function (contributionType) {
    if (contributionType === "with_form") {
        return "Contribuir";
    }
    if (contributionType === "open_contribution") {
        return "Contribuir";
    }
    return null;
};
